module.exports = __webpack_public_path__ + "static/media/4.9696c289.jpg";